<template>
  <!-- Global loading overlay, driven by the store's isLoading flag (setIsLoading). -->
  <div class="ff-loading" v-bind:class="{'is-hidden':!$store.state.isLoading}" role="status" aria-live="polite">
    <div class="ff-loading-card">
      <span class="ff-spinner"></span>
      <span>{{ $t('common.loading') }}</span>
    </div>
  </div>
  <div id="wrapper" class="is-flex is-flex-direction-column is-align-items-stretch main-layout" >
    <!-- .github/workflows/deploy-ann.yml seds the nav's class string and the logo path below
         (ann: purple bar + ANN logo) - keep both verbatim. InBill.vue hides this bar via
         #navbar-menu's parent, so #navbar-menu stays a direct child of <nav>. -->
    <nav class="navbar is-danger ff-nav">
      <div class="ff-nav-inner" id="navbar-menu">
        <div class="ff-brand">
          <img class="logo" src="@/assets/ann_profile.jpg" alt="" >
        </div>

        <!-- theo thứ tự tạo bên file route.js -->
        <div class="ff-links" v-if="isLoggedIn">
          <router-link to="/csnote" class="ff-link">CS Notes</router-link>
          <router-link to="/orderhistory" class="ff-link">Order Hist</router-link>
          <router-link to="/inship" class="ff-link" v-if="(!(isCashAccountant||localIsCashAccountant))||(isCashAccountant&&isPlaning)">In Ship</router-link>
          <!-- <router-link to="/custoperation" class="ff-link" v-if="isPlaning||localIsPlanning">Cust Op</router-link> -->
          <router-link to="/dataload" class="ff-link" v-if="(isPlaning||localIsPlanning)||(isCashAccountant||localIsCashAccountant)">Data Load</router-link>
          <router-link to="/controlpage" class="ff-link" v-if="(isPlaning||localIsPlanning)||(isCashAccountant||localIsCashAccountant)">Control Page</router-link>
          <router-link to="/settings" class="ff-link" v-if="isPlaning||localIsPlanning">Settings</router-link>
          <router-link to="/shippingtool" class="ff-link" v-if="isPlaning||localIsPlanning">Shipping Tool</router-link>
        </div>

        <div class="ff-account">
          <template v-if="isLoggedIn">
            <user-menu />
            <a class="ff-btn" @click="logout">Log Out</a>
          </template>
          <a v-else-if="$route.name !== 'login'" href="/login" class="ff-btn">Log in</a>
        </div>
      </div>
    </nav>
    <section class="section m-0	p-0 is-flex is-flex-direction-column main-layout" >
      <div class="container is-fluid m-0 p-0 is-flex main-layout"  >
        <router-view>

        </router-view>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

import { ref } from 'vue'
import UserMenu from '@/components/UserMenu.vue'

export default {
  components: { UserMenu },

  data() {
    return {
      localIsPlanning: false,
      localIsCashAccountant: false,
      localIsAuthen: false,
    }
  },

  async beforeCreate() {

    await this.$store.commit('initializeStore')

    if (this.$store.getters.isAuthenticated) {
      // this is to check token current validity
      await axios
        .get('/api/v1/user/?username=' + localStorage.getItem('user'))
        .then(response => {
          localStorage.setItem('userGroups', response.data['groups'])
          response.data['groups'].includes(1) ? this.$store.commit('setIsPlaning', true) : this.$store.commit('setIsPlaning', false)
          response.data['groups'].includes(3) ? this.$store.commit('setIsCashAccountant', true) : this.$store.commit('setIsCashAccountant', false)
        })
        .catch(error => {          
          if (error.response.status == 401) {
            this.$store.dispatch('LogOut')
            this.$router.push('/login')
          }
        })  

    } else {
      
    }

    
    // var width = document.documentElement.clientWidth * window.devicePixelRatio;
    // let viewport = document.querySelector("meta[name=viewport]");
    // viewport.setAttribute('content', 'width=' + width + ', minimum-scale= 1');
    // document.documentElement.style.transform = `scale(${1 / window.devicePixelRatio})`;
    // document.documentElement.style.transformOrigin = 'top left';


  },

  async beforeMount() {
    // console.log('beforeMount APP')
    try {
      localStorage.getItem('userGroups').split(',').includes('1') ? this.$store.commit('setIsPlaning', true) : this.$store.commit('setIsPlaning', false)
      localStorage.getItem('userGroups').split(',').includes('3') ? this.$store.commit('setIsCashAccountant', true) : this.$store.commit('setIsCashAccountant', false)

      localStorage.getItem('userGroups').split(',').includes('1') ? this.localIsPlanning = true : this.localIsPlanning = false
      localStorage.getItem('userGroups').split(',').includes('3') ? this.localIsCashAccountant = true : this.localIsCashAccountant = false

    } catch (error) {  1 == 1 }
    
    try { localStorage.getItem('token') ? (this.localIsAuthen=true) : (1==1) } catch (error) { 1 == 1 }
    
  },

  mounted() {

    // if (this.localIsAuthen) {
    //   axios
    //     .get('/api/v1/user/?username=' + localStorage.getItem('user'))
    //     .then(response => {
    //       localStorage.setItem('userGroups', response.data['groups'])
    //       response.data['groups'].includes(1) ? this.$store.commit('setIsPlaning', true) : this.$store.commit('setIsPlaning', false)
    //       response.data['groups'].includes(3) ? this.$store.commit('setIsCashAccountant', true) : this.$store.commit('setIsCashAccountant', false)
          

    //       // localStorage.getItem('userGroups').split(',').includes('1') ? this.localIsPlanning = true : this.localIsPlanning = false
    //       // localStorage.getItem('userGroups').split(',').includes('3') ? this.localIsCashAccountant = true : this.localIsCashAccountant = false

    //     })
    //     .catch(error => {          
    //       if (error.response.status == 401) {
    //         this.$store.dispatch('LogOut')
    //         this.$router.push('/login')
    //       }
    //     })  

    // } else {
      
    // }
    

  },

  updated() {
  },


  

  computed : {
      isLoggedIn : function(){ 
      
        return this.$store.getters.isAuthenticated
      },
      
      isPlaning : function(){ 
       
        return this.$store.getters.isPlaning
      },

      isCashAccountant : function(){ 
       
       return this.$store.getters.isCashAccountant
     },

      // testComputed: function() {
      //   return this.$store.getters.activeURL
      // }
      
  },

  methods: {

    async logout () {
      await this.$store.dispatch('LogOut')
      this.$router.push('/login')
      window.location.reload()
    },



    

  }
}

</script>

<style lang="scss">
@import '../node_modules/bulma/'


</style>
<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;500;600;700;800&display=swap');
</style>
<style lang="scss">



#wrapper.main-layout {
  overflow-y: hidden; 
  height: 100vh; 
  align-items: stretch;
}
// Display settings from the user menu (helpers/uiPrefs.js) land on <html> as
// data-ff-theme / data-ff-font. Only the new-style surfaces (top nav, Order Hist 2)
// read these --ff-* variables; the Bulma pages never do.
:root {
  --ff-brand: #1f7a4d;
  --ff-brand-ink: #155f3b;
  --ff-paper: #fbfaf7;
  --ff-hairline: #e7e3da;
  --ff-ink: #1d211e;
  --ff-muted: #6b716c;
  --ff-scale: 1;
  /* cards, panels, inputs, nav; the user menu's Surfaces setting tones it down */
  --ff-surface: #ffffff;
}

/* Colour theme (user menu): brand, its darker ink for text / hover, and a hairline
   tinted to match. Herb is the :root default above; helpers/uiPrefs.js THEMES lists
   the same swatches. Custom sets --ff-brand inline and derives the rest from it. */
:root[data-ff-theme="clay"] {
  --ff-brand: #bc5a33;
  --ff-brand-ink: #934323;
  --ff-hairline: #ece0d7;
}

:root[data-ff-theme="slate"] {
  --ff-brand: #2d5fa6;
  --ff-brand-ink: #224a83;
  --ff-hairline: #dfe4ec;
}

:root[data-ff-theme="custom"] {
  --ff-brand-ink: color-mix(in srgb, var(--ff-brand) 78%, #000000);
  --ff-hairline: color-mix(in srgb, var(--ff-brand) 12%, #e7e3da);
}

/* Soft / Dim take the edge off the white of cards, panels, inputs and the nav with a
   light tint of the theme's hairline tone. The page canvas is the Background setting. */
:root[data-ff-surface="soft"] { --ff-surface: color-mix(in srgb, var(--ff-hairline) 10%, #ffffff); }
:root[data-ff-surface="dim"] { --ff-surface: color-mix(in srgb, var(--ff-hairline) 22%, #ffffff); }

:root[data-ff-font="s"] { --ff-scale: 0.9; }
:root[data-ff-font="l"] { --ff-scale: 1.1; }
:root[data-ff-font="xl"] { --ff-scale: 1.22; }

// Top nav in the FitFoodee console style (Noto Sans, theme from the user menu).
// Height stays 5vh (Bulma's 3.25rem floor included) because every page sizes
// itself to 95vh.
nav.navbar.ff-nav {
  --nav-brand: var(--ff-brand);
  --nav-brand-ink: var(--ff-brand-ink);
  --nav-ink: var(--ff-ink);
  --nav-muted: var(--ff-muted);
  --nav-hairline: var(--ff-hairline);
  --nav-bg: var(--ff-surface);
  --nav-link: var(--nav-ink);
  --nav-hover-bg: color-mix(in srgb, var(--nav-brand) 7%, transparent);
  --nav-active-bg: color-mix(in srgb, var(--nav-brand) 13%, transparent);
  --nav-active-ink: var(--nav-brand-ink);
  --nav-avatar-bg: var(--nav-brand);
  --nav-avatar-ink: #ffffff;

  height: 5vh;
  min-height: 3.25rem;
  display: flex;
  align-items: stretch;
  background-color: var(--nav-bg);
  border-bottom: 1px solid var(--nav-hairline);
  color: var(--nav-ink);
  font-family: 'Noto Sans', system-ui, -apple-system, sans-serif;
  font-feature-settings: 'tnum' 1;
}

// ann build: deploy-ann.yml turns the nav's is-dark into is-danger. Keep ann's
// light-purple bar (whatever theme is picked) so the two environments stay
// easy to tell apart.
nav.navbar.ff-nav.is-danger {
  --nav-bg: #e6d9fc;
  --nav-hairline: #cdb5f7;
  --nav-brand: #8946f1;
  --nav-brand-ink: #5a24b8;
  --nav-ink: #3d1a7a;
  --nav-muted: #6f55a0;
  --nav-link: #4a2194;
  --nav-hover-bg: rgba(137, 70, 241, 0.12);
  --nav-active-bg: #ffffff;
  --nav-active-ink: #5a24b8;
  --nav-avatar-bg: #8946f1;
  --nav-avatar-ink: #ffffff;
  background-color: #e6d9fc !important;
}

.ff-nav-inner {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 16px;
}

.ff-brand {
  flex: none;
  display: flex;
  align-items: center;
}

.ff-links {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 2px;
  overflow-x: auto;
  scrollbar-width: none;
}

.ff-links::-webkit-scrollbar { display: none; }

.ff-link {
  flex: none;
  padding: 6px 12px;
  border-radius: 9px;
  color: var(--nav-link) !important;
  font-size: calc(14px * var(--ff-scale));
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
  transition: background 0.12s ease, color 0.12s ease;
}

.ff-link:hover {
  background: var(--nav-hover-bg);
  color: var(--nav-ink) !important;
}

.ff-link.router-link-exact-active,
.ff-link.router-link-active:not([href="/"]) {
  background: var(--nav-active-bg);
  color: var(--nav-active-ink) !important;
  font-weight: 700;
}

.ff-account {
  flex: none;
  display: flex;
  align-items: center;
  gap: 12px;
}

.ff-user-wrap { position: relative; }

.ff-user {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px 4px 4px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  color: var(--nav-ink);
  font: inherit;
  font-size: calc(13.5px * var(--ff-scale));
  font-weight: 700;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease;
}

.ff-user:hover,
.ff-user.is-open {
  background: var(--nav-hover-bg);
  border-color: var(--nav-hairline);
}

.ff-caret {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  opacity: 0.6;
}

.ff-avatar {
  display: inline-grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border-radius: 8px;
  background: var(--nav-avatar-bg);
  color: var(--nav-avatar-ink);
  font-size: 12px;
  font-weight: 800;
}

.ff-btn {
  padding: 5px 12px;
  border: 1px solid var(--nav-hairline);
  border-radius: 8px;
  background: transparent;
  color: var(--nav-ink) !important;
  font-size: calc(12.5px * var(--ff-scale));
  font-weight: 700;
  cursor: pointer;
  transition: background 0.12s ease;
}

.ff-btn:hover { background: var(--nav-hover-bg); }

// ---- global loading overlay: soft paper veil + a small card with a spinner.
// Fades in after 150ms so quick requests don't flash; sits above modals (2980).
.ff-loading {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: grid;
  place-items: center;
  background: color-mix(in srgb, var(--ff-paper) 55%, transparent);
  backdrop-filter: blur(2px);
  animation: ff-loading-in 0.2s ease 0.15s both;
}

.ff-loading-card {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  border: 1px solid var(--ff-hairline);
  border-radius: 14px;
  background: var(--ff-surface);
  box-shadow: 0 14px 30px -12px rgba(29, 33, 30, 0.25), 0 1px 2px rgba(29, 33, 30, 0.06);
  color: var(--ff-ink);
  font-family: 'Noto Sans', system-ui, -apple-system, sans-serif;
  font-size: calc(14px * var(--ff-scale));
  font-weight: 700;
}

.ff-spinner {
  width: 20px;
  height: 20px;
  border: 2.5px solid color-mix(in srgb, var(--ff-brand) 18%, transparent);
  border-top-color: var(--ff-brand);
  border-radius: 50%;
  animation: ff-spin 0.8s linear infinite;
}

@keyframes ff-spin { to { transform: rotate(360deg); } }
@keyframes ff-loading-in { from { opacity: 0; } to { opacity: 1; } }

// App-wide tooltip bubble for every `title` (helpers/tooltip.js places it).
.ff-tip {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5000;
  max-width: min(320px, calc(100vw - 12px));
  padding: 6px 10px;
  border-radius: 7px;
  background: var(--ff-ink);
  color: #ffffff;
  font-family: 'Noto Sans', system-ui, -apple-system, sans-serif;
  font-size: calc(12px * var(--ff-scale, 1));
  font-weight: 500;
  line-height: 1.45;
  letter-spacing: 0.01em;
  white-space: pre-line;
  overflow-wrap: anywhere;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18), 0 1px 3px rgba(0, 0, 0, 0.12);
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.12s ease, visibility 0s linear 0.12s;
}

.ff-tip.is-on {
  opacity: 1;
  visibility: visible;
  transition: opacity 0.12s ease, visibility 0s;
}

.ff-tip::after {
  content: '';
  position: absolute;
  left: var(--ff-tip-arrow, 50%);
  width: 8px;
  height: 8px;
  background: inherit;
  transform: translateX(-50%) rotate(45deg);
}

.ff-tip[data-side="below"]::after { top: -4px; }
.ff-tip[data-side="above"]::after { bottom: -4px; }

// user menu: always light, even on ann's purple bar
.ff-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 40;
  width: 280px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 14px;
  background: var(--ff-surface);
  border: 1px solid var(--ff-hairline);
  border-radius: 12px;
  box-shadow: 0 14px 26px -14px rgba(29, 33, 30, 0.32), 0 1px 2px rgba(29, 33, 30, 0.06);
  color: var(--ff-ink);
  font-size: 13px;
  text-align: left;
}

.ff-menu-label {
  margin-bottom: 7px;
  color: var(--ff-muted);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.ff-seg {
  display: flex;
  border: 1px solid var(--ff-hairline);
  border-radius: 8px;
  overflow: hidden;
}

.ff-seg button {
  flex: 1;
  height: 32px;
  border: 0;
  background: var(--ff-surface);
  color: var(--ff-muted);
  font-family: inherit;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
}

.ff-seg button + button { border-left: 1px solid var(--ff-hairline); }
.ff-seg button:hover { background: color-mix(in srgb, var(--ff-brand) 8%, var(--ff-surface)); }

.ff-seg button.is-on {
  background: color-mix(in srgb, var(--ff-brand) 14%, var(--ff-surface));
  color: var(--ff-brand-ink);
}

.ff-swatches { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 6px; }

.ff-swatch {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 4px;
  border: 1px solid var(--ff-hairline);
  border-radius: 8px;
  background: var(--ff-surface);
  color: var(--ff-ink);
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.ff-swatch:hover { border-color: color-mix(in srgb, var(--ff-ink) 25%, var(--ff-hairline)); }

.ff-swatch.is-on {
  border-color: var(--ff-brand);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--ff-brand) 20%, transparent);
}

.ff-swatch-dot { width: 12px; height: 12px; border-radius: 50%; }
.ff-swatch-bg { box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.18); }

// the custom dot is the colour input itself: a transparent native picker laid over it
.ff-swatch-picker { position: relative; overflow: hidden; box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12); }

.ff-swatch-picker input[type="color"] {
  position: absolute;
  inset: -6px;
  width: calc(100% + 12px);
  height: calc(100% + 12px);
  opacity: 0;
  cursor: pointer;
}

.ff-swatch-custom { position: relative; }

.ff-menu-note { color: var(--ff-muted); font-size: 11.5px; }

.ff-menu-guide {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin: 2px 0 10px;
  padding: 8px 10px;
  border: 1px solid color-mix(in srgb, var(--ff-brand) 35%, var(--ff-hairline));
  border-radius: 8px;
  background: color-mix(in srgb, var(--ff-brand) 7%, var(--ff-surface));
  color: var(--ff-brand-ink);
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.ff-menu-guide:hover { background: color-mix(in srgb, var(--ff-brand) 13%, var(--ff-surface)); }
.ff-menu-guide .ic { width: 16px; height: 16px; flex: none; fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }


section.main-layout {
  flex-grow: 1;
  max-height: 95vh;
  overflow-y: hidden;
}

.container.main-layout {
  flex-grow: 1; 
  max-height: 95vh; 
  overflow-y: hidden;
}



input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}

::-webkit-scrollbar {
  width: 20px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbbf;
}

td {
  padding-top: 0.4rem !important;
  padding-bottom: 0.4rem !important;
  font-size:1.1rem;
  height: auto !important;;
  // text-align: center;
}

thead:not(.thead-special-format) th {
  padding-top: 0.4rem !important;
  padding-bottom: 0.4rem !important;
  font-size:1.1rem;
  height: auto !important;;
  // text-align: center;
}

hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

</style>

<style scoped>
.logo {
  height: 4vh;
  margin-right: 5px;
}





</style>
